// Navigation and gallery interactions only. The validated purchase modules remain separate.
function initNavigation(root = document) {
  root.querySelectorAll('.av-menu:not([data-ready])').forEach(menu => {
    menu.dataset.ready = 'true';
    const trigger = menu.querySelector('summary');
    const panel = menu.querySelector('.av-menu-panel');
    let closing;
    const close = (animate = true) => {
      if (!menu.open || closing) return;
      if (animate && document.documentElement.dataset.avMotion === 'on') {
        menu.classList.add('is-closing');
        closing = setTimeout(() => { closing = null; menu.classList.remove('is-closing'); menu.open = false; }, 160);
      } else menu.open = false;
    };
    panel.querySelectorAll('.av-menu-links>a').forEach((el,i) => el.style.setProperty('--av-index', i));
    const clean = () => {
      document.documentElement.style.overflow = '';
      document.querySelectorAll('[data-av-inert]').forEach(el => { el.inert = false; delete el.dataset.avInert; });
      trigger.setAttribute('aria-expanded', 'false');
    };
    menu.addEventListener('toggle', () => {
      trigger.setAttribute('aria-expanded', String(menu.open));
      if (!menu.open) { clean(); trigger.focus(); return; }
      panel.setAttribute('role', 'dialog'); panel.setAttribute('aria-modal', 'true');
      document.documentElement.style.overflow = 'hidden';
      document.querySelectorAll('#MainContent, .page-wrapper > footer').forEach(el => {
        if (!el.inert) { el.inert = true; el.dataset.avInert = ''; }
      });
      panel.querySelector('[data-av-close]').focus();
    });
    panel.querySelector('[data-av-close]').addEventListener('click', () => close());
    panel.addEventListener('click', e => { if (e.target.closest('a')) close(false); });
    panel.addEventListener('keydown', e => {
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      if (e.key !== 'Tab') return;
      const items = [...panel.querySelectorAll('a[href],button')].filter(el => el.getClientRects().length);
      const first = items[0], last = items.at(-1);
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    matchMedia('(min-width:750px)').addEventListener('change', e => { if(e.matches) close(); });
    document.addEventListener('shopify:section:unload', e => { if(e.target.contains(menu)) clean(); });
  });
  root.querySelectorAll('.av-shop:not([data-ready])').forEach(shop => {
    shop.dataset.ready = 'true';
    document.addEventListener('click', e => { if(!shop.contains(e.target)) shop.open = false; });
    shop.addEventListener('keydown', e => { if(e.key === 'Escape') {shop.open = false; shop.querySelector('summary').focus();} });
  });
}
class AyumeCarousel extends HTMLElement {
  connectedCallback() {
    if (this.ready) return; this.ready = true;
    const track = this.querySelector('.av-carousel');
    const previous = [...this.querySelectorAll('[data-previous]')], next = [...this.querySelectorAll('[data-next]')];
    const update = () => { previous.forEach(button => button.disabled = track.scrollLeft <= 2); next.forEach(button => button.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2); };
    const move = sign => track.scrollBy({left:sign * (track.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap)),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches || document.documentElement.dataset.avMotion === 'off' ? 'instant' : 'smooth'});
    previous.forEach(button => button.addEventListener('click', () => move(-1))); next.forEach(button => button.addEventListener('click', () => move(1)));
    track.addEventListener('scroll', update, {passive:true});
    this.observer = new ResizeObserver(update); this.observer.observe(track); update();
  }
  disconnectedCallback() { this.observer?.disconnect(); this.ready = false; }
}
class AyumeCatalogue extends HTMLElement {
  connectedCallback() {
    if (this.ready) return; this.ready = true; this.abort = new AbortController();
    const signal = this.abort.signal;
    const tabs = [...this.querySelectorAll('[data-format]')];
    const panels = [...this.querySelectorAll('[data-format-panel]')];
    const use = (format, push = false) => {
      const selected = tabs.find(tab => tab.dataset.format === format) || tabs[0];
      if (!selected) return;
      tabs.forEach(tab => { const active = tab === selected; tab.setAttribute('aria-selected', String(active)); tab.tabIndex = active ? 0 : -1; });
      panels.forEach(panel => panel.hidden = panel.dataset.formatPanel !== selected.dataset.format);
      const panel = panels.find(p => !p.hidden);
      this.querySelector('[data-result-count]').textContent = panel?.dataset.countLabel || '';
      if (push) { const url = new URL(location.href); url.searchParams.set('format', selected.dataset.format); history.pushState({}, '', url); }
    };
    tabs.forEach((tab,index) => {
      tab.setAttribute('role','tab'); tab.setAttribute('aria-controls', panels[index].id);
      tab.addEventListener('click', e => { if (this.hasAttribute('data-navigate') && tab.getAttribute('aria-selected') !== 'true') return; e.preventDefault(); use(tab.dataset.format, true); },{signal});
      tab.addEventListener('keydown', e => {
        if (!['ArrowLeft','ArrowRight','Home','End'].includes(e.key)) return;
        e.preventDefault();
        const dest = e.key === 'Home' ? tabs[0] : e.key === 'End' ? tabs.at(-1) : tabs[(index + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
        if (this.hasAttribute('data-navigate') && dest.getAttribute('aria-selected') !== 'true') { location.href = dest.href; return; } use(dest.dataset.format, true); dest.focus();
      },{signal});
    });
    this.querySelector('.av-tabs')?.setAttribute('role','tablist');
    panels.forEach(panel => panel.setAttribute('role','tabpanel'));
    const restore = () => use((!this.hasAttribute('data-navigate') && new URL(location.href).searchParams.get('format')) || this.dataset.initial || 'classic');
    window.addEventListener('popstate', restore,{signal}); restore();
    const dialog = this.querySelector('dialog'), opener = this.querySelector('[data-compare]');
    opener?.addEventListener('click', () => dialog.showModal(),{signal});
    dialog?.querySelector('[data-close]')?.addEventListener('click', () => dialog.close(),{signal});
    dialog?.addEventListener('close', () => opener.focus(),{signal});
    dialog?.addEventListener('click', e => { if(e.target === dialog) {const r=dialog.getBoundingClientRect(); if(e.clientX<r.left || e.clientX>r.right || e.clientY<r.top || e.clientY>r.bottom) dialog.close();} },{signal});
  }
  disconnectedCallback() { this.abort?.abort(); this.ready = false; }
}
if (!customElements.get('ayume-carousel')) customElements.define('ayume-carousel', AyumeCarousel);
if (!customElements.get('ayume-catalogue')) customElements.define('ayume-catalogue', AyumeCatalogue);
initNavigation();
document.addEventListener('shopify:section:load', e => initNavigation(e.target));
try {
  const {StandardEvents} = await import('@shopify/events');
  document.addEventListener(StandardEvents.cartLinesUpdate, async e => {
    try {
      const result = await e.promise;
      const cart = result.cart;
      const count = cart.totalQuantity ?? cart.itemCount ?? cart.item_count;
      if (typeof count !== 'number') return;
      document.querySelectorAll('[data-av-count]').forEach(el => el.textContent = String(count).padStart(2,'0'));
    } catch { /* A badge must never trigger another purchase. */ }
  });
} catch { /* Server-rendered count stays available. */ }

